import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/index'
    // component: resolve => require(['@/views/index.vue'], resolve)
  },
  {
    path: '/index',
    name: 'index',
    component: resolve => require(['@/views/index.vue'], resolve)
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: resolve => require(['@/views/aboutUs.vue'], resolve)
  },
  {
    path: '/certification',
    name: 'certification',
    component: resolve => require(['@/views/certification.vue'], resolve)
  },
  {
    path: '/fabric',
    name: 'fabric',
    component: resolve => require(['@/views/fabric.vue'], resolve)
  },
  {
    path: '/garment',
    name: 'garment',
    component: resolve => require(['@/views/garment.vue'], resolve)
  },
  {
    path: '/schoolUniform',
    name: 'schoolUniform',
    component: resolve => require(['@/views/schoolUniform.vue'], resolve)
  },
  {
    path: '/customMade',
    name: 'customMade',
    component: resolve => require(['@/views/customMade.vue'], resolve)
  },
  {
    path: '/qualityControl',
    name: 'qualityControl',
    component: resolve => require(['@/views/qualityControl.vue'], resolve)
  },
  {
    path: '/contact',
    name: 'contact',
    component: resolve => require(['@/views/contact.vue'], resolve)
  }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
